var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.preloaded)?_c('filters-form',{attrs:{"initial":_vm.initial,"items":_vm.items,"loading":_vm.loading,"filters":_vm.filters,"schema":_vm.schema,"payload":_vm.payload,"actions":_vm.actions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }